import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
} from 'reactstrap';

import MaterialCard from './components/MaterialCard';
import usePackagingMaterials from './hooks/usePackagingMaterials';

const PackagingMaterialOverviewSkeleton = () => (
    <Card className="mb-4">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '30%', height: '24px' }} />
            <Row className="g-3">
                {[1, 2, 3, 4].map((item) => (
                    <Col key={item} xs="12" sm="6" md="3">
                        <div className="dt-field dt-skeleton" style={{ width: '100%', height: '160px' }} />
                    </Col>
                ))}
            </Row>
        </CardBody>
    </Card>
);

const PackagingMaterialOverview = ({
    t,
}) => {
    const {
        data: materials,
        isLoading,
        isFetching,
        isError,
    } = usePackagingMaterials({ t });

    if (isLoading || isFetching) {
        return <PackagingMaterialOverviewSkeleton />;
    }

    if (isError || !materials?.length) {
        return null;
    }

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h6" className="mb-4">
                    {t('Packaging Material Overview')}
                </CardTitle>

                <Row className="g-3">
                    {materials.map((material) => (
                        <Col key={material.name} xs="12" sm="6" md="3">
                            <MaterialCard
                                name={material.name}
                                itemCount={material.itemCount}
                                riskLevel={material.riskLevel}
                                compliancePercentage={material.compliancePercentage}
                            />
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(PackagingMaterialOverview);
